module.exports = __webpack_public_path__ + "static/media/pen.ead6d05e.svg";